import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import './PhyelementsMain.css';

export default function HomeSlider({title, description, imgPath}) {
  return (
    <Grid
      container
      spacing={2}
      sx={{ padding: { xs: 2, sm: 0, md: 0 } }}
      flexWrap={"wrap-reverse"}
    >
      <Grid item xs={0} sm={0} md={0.5} />

      <Grid item xs={12} sm={7} md={7}>
        <Box
          className="left-slider-box"
          sx={{ height: { xs: "22vh", sm: "40vh", md: "50vh" } }}
        >
          <Box sx={{ width: { sm: "60%", md: "60%"}, padding: {xs: "10px"} }}>
            <Typography
              component="h3"
              className="slider-heading"
              sx={{
                fontSize: {
                  xs: "1rem", // phones
                  sm: "1.25rem", // tablets
                  md: "1.8rem", // desktops
                },
              }}
            >
              {title}
            </Typography>
            <Typography
              className="slider-description"
              sx={{
                fontSize: {
                  xs: "0.8rem", // phones
                  sm: "0.9rem", // tablets
                  md: "1rem", // desktops
                },
              }}
            >
              {description}
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} sm={4} md={4}>
        <Box
          className="right-slider-image-box"
          sx={{ height: { xs: "22vh", sm: "40vh", md: "50vh" } }}
        >
          <img src={imgPath}></img>
        </Box>
      </Grid>
      <Grid item xs={0} sm={0} md={0.5} />
    </Grid>
  );
}
